import {
  CompareItem,
  CompareLocale,
} from '_components/Product/FranchiseCompareTable/types';

export type FranchiseAttributeType =
  | 'name'
  | 'price'
  | 'rating'
  | 'cta'
  | 'idealFor'
  | 'techspec';

const NAME_KEYS = ['name', 'nom'];
const PRICE_KEYS = ['price', 'prix'];
const RATING_KEYS = ['rating', 'évaluations'];
const CTA_KEYS = ['cta'];
// Matched on letters only, so the Akeneo code (`ideal_for`) and the EN/FR
// labels ("Ideal for", "Idéal pour") all resolve to the same attribute.
const IDEAL_FOR_KEYS = ['idealfor', 'idealpour'];

const toLetters = (key: string): string =>
  key
    .normalize('NFD')
    .replace(/[̀-ͯ]/g, '')
    .replace(/[^a-z]/g, '');

export function getFranchiseAttributeType(
  specKey: string
): FranchiseAttributeType {
  const key = specKey.toLowerCase();
  if (NAME_KEYS.includes(key)) return 'name';
  if (PRICE_KEYS.includes(key)) return 'price';
  if (RATING_KEYS.includes(key)) return 'rating';
  if (CTA_KEYS.includes(key)) return 'cta';
  if (IDEAL_FOR_KEYS.includes(toLetters(key))) return 'idealFor';
  return 'techspec';
}

export function getCompareSpecArray(
  item: CompareItem,
  code: string,
  locale: CompareLocale
): string[] | null {
  const val = item.comparisonSpecs?.[code]?.[locale];
  if (!val) return null;
  const items = (Array.isArray(val) ? val : [val]).filter(
    (entry) => !!entry && entry !== '0'
  );
  return items.length > 0 ? items : null;
}

export function getCompareSpecValue(
  item: CompareItem,
  code: string,
  locale: CompareLocale
): string | null {
  return getCompareSpecArray(item, code, locale)?.join(', ') ?? null;
}
